import { render, staticRenderFns } from "./SetTotp.vue?vue&type=template&id=63f042b0"
import script from "./SetTotp.vue?vue&type=script&lang=js"
export * from "./SetTotp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports